// extracted by css-extract-rspack-plugin
export default {"root":"ituF5HD5SYUgFKeK","divider":"tMprj0QMOxcsqg77","row":"xACijrlYKvIXNrqu","label":"Mp5PSlUU4Qc0AlW9","switch":"rG3CG3aUy73ISd68"};